import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=61a93569&scoped=true&"
import script from "./confirm.vue?vue&type=script&lang=js&"
export * from "./confirm.vue?vue&type=script&lang=js&"
import style0 from "./confirm.vue?vue&type=style&index=0&id=61a93569&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a93569",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a93569')) {
      api.createRecord('61a93569', component.options)
    } else {
      api.reload('61a93569', component.options)
    }
    module.hot.accept("./confirm.vue?vue&type=template&id=61a93569&scoped=true&", function () {
      api.rerender('61a93569', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/mintage/confirm.vue"
export default component.exports